import * as yup from "yup";

const MarcaLlantaValidacionEsquema = yup.object().shape({
    nombre: yup.string().required()
});

export default MarcaLlantaValidacionEsquema;